import { ChatProvider } from "./contexts/ChatContext";
import AssistantSelector from "./components/AssistantSelector";
import ChatWindow from "./components/ChatWindow";
import { useState, useEffect } from "react";
import DemoRoleSwitcher from "./components/DemoRoleSwitcher";
import ModelBadge from "./components/ModelBadge";


function MainApp({ userInfo }) {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", darkMode);
  }, [darkMode]);

  console.log("Selected Model : " + localStorage.getItem("selectedModel"))

  return (
    <ChatProvider>
      <div className="min-h-screen bg-gray-100 dark:bg-gray-900 transition-colors duration-300 flex justify-center p-4">
        <div className="w-full max-w-2xl bg-white dark:bg-gray-800 text-gray-800 dark:text-white rounded-xl shadow p-6 space-y-4">
          
          <div className="flex justify-between items-center mb-4">
            {/* Left: Title */}
            <h1 className="text-3xl font-bold">ARC AI</h1>

            {/* Center: Logo */}
            <div className="absolute left-1/2 transform -translate-x-1/2">
              <img src={darkMode ? "/logos/Medium/White/RGB/ARC-Logo-M-White-RGB.png" : "/logos/Medium/Teal/RGB/ARC-Logo-M-Teal-RGB.png"} alt="Company Logo" className="h-10" />
            </div>

            {/* Right: Dark Mode Toggle */}
            <div className="flex-1 flex justify-end"></div>
              <button
                onClick={() => setDarkMode(!darkMode)}
                className="bg-gray-200 dark:bg-gray-700 px-4 py-2 rounded text-sm"
              >
                {darkMode ? "☀️ Light" : "🌙 Dark"} Mode
              </button>
            </div>
        

          {/* ✅ Show user info here */}
          {userInfo && (
            <div className="text-sm text-right text-gray-500 dark:text-gray-300">
              Logged in as: {userInfo.email || userInfo.name}
            </div>
          )}

          <AssistantSelector />
          <DemoRoleSwitcher />
          <ModelBadge modelKey={localStorage.getItem("selectedModel")}/>
          <ChatWindow />
    
        </div>
      </div>
    </ChatProvider>
  );
}

export default MainApp;